import { render, staticRenderFns } from "./Posete.vue?vue&type=template&id=68aa9082&scoped=true&"
import script from "./Posete.vue?vue&type=script&lang=ts&"
export * from "./Posete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aa9082",
  null
  
)

export default component.exports